import React from 'react';
import { useParams } from 'react-router-dom';

import { useRoleLoad } from './hooks';
import RoleSetup from './RoleSetup';

const RoleEdit = () => {
  const { id } = useParams<{ id: string }>();

  const { isLoading } = useRoleLoad(id);

  return <RoleSetup isEditMode isLoading={isLoading} />;
};

export default RoleEdit;
